import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { SimpleSpanProcessor, ConsoleSpanExporter, BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { Resource } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';

const enableTracing = false; // Symmetrically deactivated to prevent console 504 logs in production!

if (!enableTracing) {
  console.log('OpenTelemetry browser-side tracing deactivated to optimize network resources.');
} else {
  try {
    // Initialize the provider with a resource
    const provider = new WebTracerProvider({
      resource: new Resource({
        [ATTR_SERVICE_NAME]: 'opengadget-storefront-frontend',
      }),
    });

    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const collectorUrl = isLocal ? 'http://localhost:4318/v1/traces' : `${window.location.origin}/v1/traces`;

    const otlpExporter = new OTLPTraceExporter({
      url: collectorUrl,
      credentials: 'omit', // Force browser to omit credentials/cookies for cross-origin wildcard CORS compatibility!
    });

    // Add span processors
    if (typeof provider.addSpanProcessor === 'function') {
      // Use BatchSpanProcessor for better performance and resilience
      provider.addSpanProcessor(new BatchSpanProcessor(otlpExporter));
    } else {
      console.warn('OpenTelemetry: provider.addSpanProcessor is not a function.');
    }

    // Optional: Add console exporter for development
    if (isLocal && typeof provider.addSpanProcessor === 'function') {
      provider.addSpanProcessor(new SimpleSpanProcessor(new ConsoleSpanExporter()));
    }

    // Register the provider
    provider.register({
      contextManager: new ZoneContextManager(),
    });

    // Register instrumentations
    registerInstrumentations({
      instrumentations: [
        new FetchInstrumentation({
          ignoreUrls: [/localhost:3000\/sockjs-node/, /socket\.io/, /otel-collector\.opengadget\.com/],
        }),
        new XMLHttpRequestInstrumentation({
          ignoreUrls: [/localhost:3000\/sockjs-node/, /socket\.io/, /otel-collector\.opengadget\.com/],
        }),
      ],
    });
    console.log(`OpenTelemetry browser-side tracing initialized pointing to: ${collectorUrl}`);
  } catch (error) {
    console.warn('OpenTelemetry initialization failed (non-fatal):', error);
  }
}
